/**
 * BrandsServices.tsx — Gold Garage Door / Brands · Section 5/8
 * Navy · "What we do — any brand" · 6 service cards linking to existing service pages.
 * Internal SEO routing hub. Plain <a> tags (no Link import) for compatibility.
 * MOBILE: real <style> media queries.
 * 10WEB AI: keep inline SVG + <style>. Wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";

/** wrench — DO NOT REPLACE WITH IMG */
const IconWrench = () => <svg data-icon-container="lucide-do-not-replace" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" /></svg>;
/** cog — DO NOT REPLACE WITH IMG */
const IconCog = () => <svg data-icon-container="lucide-do-not-replace" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" /><path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" /><path d="M12 2v2M12 20v2M20 12h2M2 12h2" /></svg>;
/** spring/activity — DO NOT REPLACE WITH IMG */
const IconSpring = () => <svg data-icon-container="lucide-do-not-replace" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></svg>;
/** radio/remote — DO NOT REPLACE WITH IMG */
const IconRadio = () => <svg data-icon-container="lucide-do-not-replace" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5M19.1 4.9C23 8.8 23 15.2 19.1 19.1" /><circle cx="12" cy="12" r="2" /></svg>;
/** plus-square/install — DO NOT REPLACE WITH IMG */
const IconInstall = () => <svg data-icon-container="lucide-do-not-replace" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" /><path d="M12 8v8M8 12h8" /></svg>;
/** roller — DO NOT REPLACE WITH IMG */
const IconRoller = () => <svg data-icon-container="lucide-do-not-replace" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="1" /><path d="M3 9h18M3 13h18M3 17h18" /></svg>;
const SERVICES = [{
  icon: <IconCog />,
  title: "Motor & opener repair",
  body: "B&D, Merlin, ATA, LiftMaster & Grifco motors diagnosed and repaired.",
  href: "/garage-door-motor-repair-sydney/"
}, {
  icon: <IconSpring />,
  title: "Spring replacement",
  body: "Torsion & extension springs matched to your door's brand and weight.",
  href: "/garage-door-spring-replacement-sydney/"
}, {
  icon: <IconRadio />,
  title: "Remote & keypad",
  body: "Genuine remotes and keypad reprogramming for every brand.",
  href: "/garage-door-remote-programming-sydney/"
}, {
  icon: <IconWrench />,
  title: "General repairs",
  body: "Cables, rollers, tracks and panels — any make, any model.",
  href: "/garage-door-repair-sydney/"
}, {
  icon: <IconRoller />,
  title: "Roller door service",
  body: "Steel-Line, Gliderol & B&D Roll-A-Door repairs and replacements.",
  href: "/roller-door-repair-sydney/"
}, {
  icon: <IconInstall />,
  title: "New installations",
  body: "Supply & install of any brand — sectional, roller or insulated.",
  href: "/garage-door-installation-sydney/"
}];
export default function BrandsServices() {
  return <section id="brands-services" style={{
    background: `radial-gradient(ellipse at 80% 100%, #14254d 0%, ${NAVY} 55%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`
        .bs-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.25rem; }
        @media (max-width: 880px) { .bs-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 560px) {
          .bs-grid { grid-template-columns: 1fr; }
          #brands-services { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}><filter id="grain-bs"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter><rect width="100%" height="100%" filter="url(#grain-bs)" /></svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        textAlign: "center",
        maxWidth: "620px",
        margin: "0 auto 3rem"
      }}>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD,
          textTransform: "uppercase"
        }}>Any Brand, Any Job</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.65rem, 6vw, 2.6rem)",
          color: "#FFFFFF",
          lineHeight: 1.15,
          margin: "0.75rem 0 0"
        }}>What we do across every brand</h2>
        </div>

        <div className="bs-grid">
          {SERVICES.map((s, i) => <a key={i} href={s.href} style={{
          textDecoration: "none",
          display: "block",
          height: "100%"
        }}>
              <div style={{
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "14px",
            padding: "1.75rem",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "0.85rem"
          }}>
                <div style={{
              width: "48px",
              height: "48px",
              borderRadius: "12px",
              background: `${GOLD}1A`,
              border: `1px solid ${GOLD}33`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>{s.icon}</div>
                <h3 style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: "1.1rem",
              color: "#fff",
              lineHeight: 1.25
            }}>{s.title}</h3>
                <p style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.9rem",
              color: "rgba(255,255,255,0.65)",
              lineHeight: 1.6,
              flexGrow: 1
            }}>{s.body}</p>
                <span style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700,
              fontSize: "0.88rem",
              color: GOLD
            }}>Learn more →</span>
              </div>
            </a>)}
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>
    </section>;
}